import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap, catchError} from 'rxjs/operators';

export class MyHttpRequest<T> extends HttpRequest<any> {
	public id: any;

	public constructor() {
		super('GET', '', {});
	}
}

@Injectable()
export class FrameworkHttpInterceptor
	implements HttpInterceptor {

	public static queries = {};
	public static count = {http: 0};
	public static queriesCount = 0;

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		FrameworkHttpInterceptor.queriesCount++;
		const newReq = new MyHttpRequest();
		Object.assign(newReq, req);
		newReq.id = FrameworkHttpInterceptor.queriesCount;
		FrameworkHttpInterceptor.queries[newReq.id] = newReq;
		FrameworkHttpInterceptor.count.http++;
		return next.handle(newReq).pipe(
			tap(evt => {
				// console.log('HTTP++', evt);
				if (evt instanceof HttpResponse) {
					FrameworkHttpInterceptor.count.http--;
					delete FrameworkHttpInterceptor.queries[newReq.id];
				} else {
				}

				return evt;
			}, (err) => {
				// console.log('HTTP--', err);
				FrameworkHttpInterceptor.count.http--;
				delete FrameworkHttpInterceptor.queries[newReq.id];
				console.log('http in error', {err});

				return err;
			}));
	}
}
